<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>                    
                    <el-button type="primary" @click="addDepartment()" style="width: 96px">新增</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="title" label="科室"></el-table-column>
                    <el-table-column label="图片">
                       <template width="120px" slot-scope="scope">

                        <img style="width:80px;height:80px;border:none;" :src="formatImage(scope.row.imagePath)" >

                        </template>
                    </el-table-column> 
                    <el-table-column prop="message" label="科室介绍"></el-table-column>
                    <el-table-column prop="hotType" label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.hotType === 1">热门</span>
                            
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                        <span v-if="scope.row.hotType === 1">
                           <el-button type="text" @click="cancleHot(scope.row)">取消热门</el-button>
                        </span>                        
                        <span v-else>
                           <el-button type="text" @click="setHot(scope.row)">设置热门</el-button>
                        </span>
                        <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
    
        </div>
        <el-dialog title="新增科室" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="departmentAdd" :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item label="科室名称:" prop="title">
                    <el-input v-model="departmentAdd.title" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="科室详情:" prop="message">
                    
                    <!--<el-input v-model="departmentAdd.message" style="width: 320px"></el-input>-->
                    <quill-editor v-model="departmentAdd.message" ref="editor" :options="editorOption">
                    </quill-editor>
                </el-form-item>         
               
                
               <el-form-item label="科室图片:" prop="imagePath">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="departmentAdd.imagePath"  class="course-img" :src="formatImage(departmentAdd.imagePath)"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑科室" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="departmentEdit" :rules="rules" ref="edit" size="small" label-width="90px">
                <el-form-item label="科室名称:" prop="title">
                    <el-input v-model="departmentEdit.title" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="科室详情:" prop="message">
                    <!--<el-input v-model="departmentEdit.message" style="width: 320px"></el-input>-->
                     <quill-editor v-model="departmentEdit.message" ref="editor" :options="editorOption">
                    </quill-editor>
                </el-form-item>
                 <el-form-item label="科室图片:" prop="imagePath">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="departmentEdit.imagePath"  class="course-img" :src="formatImage(departmentEdit.imagePath)"></el-image>
                            <input type="file" class="upload-input" @change="editImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>             
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
    quillEditor
    } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    export default {
        components: {
        quillEditor
        },
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                tableData: [],
                dialogAddVisible:false,
                departmentAdd:{
                    title:'',
                    message:'',
                    imagePath:''

                },
                editorOption: {},
                rules: {
                    title: [{required: true, message: '请输入科室名称', trigger: 'blur'}],      
                                  
                },
                dialogEditVisible:false,
                departmentEdit:{
                    id:'',
                    title:'',
                    message:'',
                    imagePath:''
                }
                
               
            };
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true                
                this.axios.get('api-b/10046/100179/0',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data
                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    
                    this.loading = false
                })
            },
           formatImage(imageurl) {
                let baseurl = "http://test.zgtyyy.com/chinesemedicine";                 
                return imageurl ? baseurl + imageurl : baseurl + "/src/images/default.png"
                
            },
            uploadImg(data) {
            return new Promise(resolve => {
                this.axios.post('/api-f/10027/100065',data,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
                }).then(res => {
                    resolve(res)
                })
            })
        },
        addImg(){
            let inputDOM = this.$refs.picture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'doctorProperty')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.departmentAdd.imagePath = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        // 修改图像
        editImg(){
            let inputDOM = this.$refs.editPicture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'doctorProperty')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.departmentEdit.imagePath = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        cancelAdd() {
            this.dialogAddVisible = false
            this.$nextTick(() => {
                this.$refs.add.resetFields()
            })
        },
        // 新增科室弹窗按钮
        addDepartment() {            
            this.dialogAddVisible = true
        },
        confirmAdd(){
            this.$refs.add.validate(valid => {                                            
                let params = {
                    title:this.departmentAdd.title,
                    message:this.departmentAdd.message,
                    imagePath:this.departmentAdd.imagePath,
                    state:0
                                                
                }
                this.axios.post('api-b/10046/100180/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                    
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                
            })

        },
        cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
        // 编辑医生弹窗按钮
        edit(data) {
            
            this.axios.get('/api-b/10046/100181/' + data.id,{
            headers:{
                Authorization: this.authorization,
            }
            }).then(res => {
                
                if(res.data.code=== 10000) {
                    if (res.data.data !== null) {
                        this.dialogEditVisible = true
                        this.departmentEdit = res.data.data
                        
                    } else {
                        this.$message.info(res.data.message)
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
            
        confirmEdit() {
            this.$refs.edit.validate(valid => {
                console.log(this.$refs.editor.value)
                let params = {
                    id:this.departmentEdit.id,
                    title:this.departmentEdit.title,
                    message:this.departmentEdit.message,
                    imagePath:this.departmentEdit.imagePath,
                    state:0
                                                
                }
                this.axios.post('/api-b/10046/100180',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.edit.resetFields()                            
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

               
            })
        },
        cancleHot(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要取消设置该科室为热门吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let params = {
                    id:data.id,
                    hotType:0
                }
                
                this.axios.post('/api-b/10046/100182',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        },
        setHot(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要设置该科室为热门吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let params = {
                    id:data.id,
                    hotType:1
                }
                
                this.axios.post('/api-b/10046/100182',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        },
        del(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要删除该科室吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {                
                
                this.axios.get('/api-b/10046/100183/' + data.id,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        }

           
        },
        watch: {
            
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>